import { useEffect } from "react";

import ClientDetailProvider from "../../../../../components/cm/Dashboard/FullPages/ClientDetail/context/ClientDetailContext";
import Appointments from "../../../../../components/modules/appointments/Appointments";
import Navigation from "../../../../../components/navigations/client/detail/medical/navigation";
import useParentLoaderData from "../../../../../hooks/useParentLoaderData";
import { useQueryParams } from "../../../../../hooks/useQueryParams";
import { NavigationHistoryService } from "../../../../../services/navigation-history-service";

export default () => {
  const { _case, _clientId } = useParentLoaderData(2);
  const { updateFilter } = useQueryParams();

  useEffect(() => {
    const navService = new NavigationHistoryService();
    navService.save("client-detail", "/medical/appointments");
  }, []);

  useEffect(() => {
    if (_clientId !== null) {
      const current = new URL(window.location.href);
      const currentClient = current.searchParams.get("client");
      if (String(currentClient) !== String(_clientId)) {
        updateFilter("client", String(_clientId), null, true);
      }
    }
  }, [_clientId]);

  return (
    <Navigation activeTab="appointments" _case={_case}>
      <ClientDetailProvider>
        <Appointments caseInfo={_case} />
      </ClientDetailProvider>
    </Navigation>
  );
};
